var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,32c-74,0-134.2,58.7-134.2,132.7c0,16.4,3.5,34.3,9.8,50.4l-0.1,0l0.6,1.2l0,0c0.5,1.1,1,2.2,1.5,3.3L256,480   l121.8-259.1l0.6-1.2c0.5-1.1,1.1-2.2,1.6-3.4l0.4-1.1c6.5-16.1,9.8-33.1,9.8-50.3C390.2,90.7,330,32,256,32z M365.1,209.4   l-0.2,0.5c-0.3,0.6-0.6,1.3-0.9,1.9l-1,2.1L256,441.3L148.9,213.9l-0.9-2c-0.3-0.6-0.6-1.2-0.8-1.8c-5.9-14.5-9.1-30.6-9.1-45.4   c0-65,52.9-116.5,118-116.5s118,51.4,118,116.5C374,179.9,371,194.9,365.1,209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,96c-35.3,0-64,28.7-64,64s28.7,64,64,64s64-28.7,64-64S291.3,96,256,96z M256,206.9c-25.9,0-46.9-21-46.9-46.9   c0-25.9,21-46.9,46.9-46.9c25.9,0,46.9,21,46.9,46.9C302.9,185.9,281.9,206.9,256,206.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a0852329df31829d6af70e7da86a3773.svg";
export { ForwardRef as ReactComponent };